/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ButtonBase,
  IconButton,
  Paper,
  Typography,
  Fade
} from '@material-ui/core'
import LeftArrowIcon from '@material-ui/icons/ChevronLeft'
import RightArrowIcon from '@material-ui/icons/ChevronRight'
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow'
import moment from 'moment-jalaali'
import { useEffect, useMemo, useRef, useState } from 'react'

import {
  formatDateFullObject,
  getDatesList,
  addDaysToDate,
  getTodayDate,
  DateObject,
  isWeekend
} from '../../../helpers/date'
import { lang } from '../../../localization'
import useStyles from './styles/InventoryDateRowMobile.styles'

interface InventoryDateRowProps {
  selectedDateInDatePicker: DateObject
  setselectedDateInDatePicker: React.Dispatch<React.SetStateAction<DateObject>>
  range?: 'TWO_WEEKS' | 'MONTH'
}

const InventoryDateRow: React.FC<InventoryDateRowProps> = ({
  selectedDateInDatePicker,
  setselectedDateInDatePicker,
  range = 'TWO_WEEKS'
}) => {
  const classes = useStyles()

  const perPage = useMemo(() => (range === 'TWO_WEEKS' ? 14 : 31), [range])

  const [isOpen, setisOpen] = useState(false)
  const wrapperRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef?.current?.contains(event.target as Node) &&
        isOpen
      ) {
        setisOpen(false)
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef, isOpen])

  const datesList = useMemo(
    () => getDatesList(perPage, selectedDateInDatePicker.gregorianStartDate),
    [perPage, selectedDateInDatePicker.gregorianStartDate]
  )

  return (
    <Paper
      className={
        range === 'TWO_WEEKS' ? classes.paperWeekly : classes.paperMonthly
      }
      elevation={5}>
      <div className={classes.daysContainer}>
        <div className={[classes.dayContainer].join(' ')} />
        {datesList.map((item) => (
          <div
            className={[
              classes.dayContainer,
              isWeekend(item) ? classes.weekendDayContainer : '',
              range === 'MONTH' ? classes.dayContainerSmall : ''
            ].join(' ')}
            key={item.gregorianDate.date}>
            <Typography variant="h4">
              {item[lang === 'fa' ? 'jalaaliDate' : 'gregorianDate'].monthDay}
            </Typography>
            <span>
              {item[lang === 'fa' ? 'jalaaliDate' : 'gregorianDate'].month}
            </span>
          </div>
        ))}
      </div>
    </Paper>
  )
}

export default InventoryDateRow
